var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({model:{value:(_vm.percented),callback:function ($$v) {_vm.percented=$$v},expression:"percented"}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }